const title = state => state.title
const links = state => state.links
const fineplay = state => state.fineplay
const enableFineplay = state => state.enableFineplay

export default {
  title,
  links,
  fineplay,
  enableFineplay
}



// WEBPACK FOOTER //
// ./src/store/modules/navigator/getters.js